document.addEventListener('DOMContentLoaded', function () {
  const roleNcp = 3
  const roleOspeNcp = 6

  const formEl = document.querySelector('.admin.users-form')
  if (formEl instanceof HTMLElement) {

    //
    // OSP NCP handling
    //
    const repRoleCb = document.querySelector(`input[ref='user-role'][value='${roleNcp}']`)
    const ncpSelectEl = document.querySelector('select[ref="ncp-organisation"]')

    // $(repCountrySelect).select2()
    if (repRoleCb instanceof HTMLInputElement && ncpSelectEl instanceof HTMLSelectElement) {
      const enableNcpOrg = function (): void {
        ncpSelectEl.disabled = !repRoleCb.checked
      }

      repRoleCb.addEventListener('change', function () {
        enableNcpOrg()
      })

      enableNcpOrg()
    }

    //
    // OSPE NCP handling
    //
    const ospeNcpCb = document.querySelector(`input[ref='user-role'][value='${roleOspeNcp}']`)
    const ospeNcpSelect = document.querySelector('select[ref="ospe-ncp-organisation"]')
    if (ospeNcpCb instanceof HTMLInputElement && ospeNcpSelect instanceof HTMLSelectElement) {
      const enableOspeNcpOrg = function (): void {
        ospeNcpSelect.disabled = !ospeNcpCb.checked
      }

      ospeNcpCb.addEventListener('change', function () {
        enableOspeNcpOrg()
      })

      enableOspeNcpOrg()
    }
  }
})
